// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag-input[data-v-2f0ab1ce] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.tag-input div[data-v-2f0ab1ce] {\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n  border: 1px solid black;\n  border-radius: 5px;\n  margin: 1px 3px;\n  padding: 1px 2px;\n  font-size: smaller;\n}\n.tag-input input[data-v-2f0ab1ce] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}", ""]);
// Exports
module.exports = exports;
